import { EmptyDataMessage } from "@/common/components/EmptyDataMessage";
import { ErrorMessageWrapper } from "@/common/components/ErrorMessageWrapper";
import { maintenanceForwardingsDirectiveEntryKlasses } from "@/features/maintenance/features/workflows/constants/forwardings/maintenanceForwardingsDirectiveEntryKlasses.constant";
import { ForwardingTabContext } from "@/features/maintenance/features/workflows/hooks/forwardings/useForwardingTabContext";
import { useMaintenanceForwarding } from "@/features/maintenance/features/workflows/hooks/forwardings/useMaintenanceForwarding";
import { useWorkflowShowStore } from "@/features/maintenance/features/workflows/stores/workflowShowStore";
import { MaintenanceForwardingsDirectiveEntryKlass } from "@/features/maintenance/features/workflows/types/forwardings/maintenanceForwardingsDirectiveEntryKlasses.type";
import { useEffect, useMemo } from "react";
import MaintenanceWorkflowForwardingShowLoading from "./MaintenanceWorkflowForwardingShowLoading";
import { MaintenanceForwardingData } from "@/features/maintenance/features/workflows/types/forwardings/maintenanceForwarding.type";

interface MaintenanceWorkflowForwardingShowProps {
  forwardingId: string;
  directiveEntryKlass: MaintenanceForwardingsDirectiveEntryKlass;
  noActions?: boolean;
}

const MaintenanceWorkflowForwardingShow = ({
  forwardingId,
  directiveEntryKlass,
  noActions,
}: MaintenanceWorkflowForwardingShowProps) => {
  const { setForwarding } = useWorkflowShowStore();

  const {
    data: forwarding,
    isPending: forwardingIsPending,
    error: forwardingError = {} as any,
    refetch: refetchForwarding,
    dataUpdatedAt: forwardingUpdatedAt,
  } = useMaintenanceForwarding(forwardingId);

  const ForwardingStateComponent = useMemo(() => {
    const maintenaceDirectiveEntryData = maintenanceForwardingsDirectiveEntryKlasses[directiveEntryKlass];

    if (!maintenaceDirectiveEntryData) {
      return false;
    }

    const directiveEntryStatusData = forwarding?.status && maintenaceDirectiveEntryData.status[forwarding.status];

    if (!directiveEntryStatusData) {
      return false;
    }

    return directiveEntryStatusData.component || false;
  }, [directiveEntryKlass, forwarding?.status]);

  useEffect(() => {
    if (noActions) return;

    setForwarding(forwarding as MaintenanceForwardingData | undefined);
  }, [forwardingUpdatedAt, noActions]);

  if (forwardingIsPending) {
    return <MaintenanceWorkflowForwardingShowLoading />
  }

  return (
    <ErrorMessageWrapper
      className="flex-1"
      statusCode={forwardingError?.status}
      refetchFunction={refetchForwarding}
    >
      {forwarding && ForwardingStateComponent && (
        <ForwardingTabContext.Provider
          value={{
            forwarding,
            forwardingUpdatedAt,
            directiveEntryKlass,
          }}
        >
          <div className="flex-1 overflow-auto flex flex-col gap-4">
            <ForwardingStateComponent />
          </div>
        </ForwardingTabContext.Provider>
      )}

      {(!forwarding || !ForwardingStateComponent) && (
        <EmptyDataMessage className="flex-1" />
      )}
    </ErrorMessageWrapper>
  );
}

export default MaintenanceWorkflowForwardingShow;
